import { GrowthBook } from "@growthbook/growthbook";
import { logRollbarError } from "@/utils/rollbar.util";

const growthbookApiHost = import.meta.env.APP_GROWTHBOOK_API_HOST;
const growthbookClientKey = import.meta.env.APP_GROWTHBOOK_CLIENT_KEY;
const growthbookEnableDevMode = import.meta.env.APP_GROWTHBOOK_ENABLE_DEV_MODE;

// autoAttributesPlugin is intentionally NOT registered: in Capacitor native
// builds it injects host=localhost / url=capacitor://localhost which breaks
// URL-based GrowthBook targeting. Attributes are owned by middleware/permission.js.

const isNativePlatform = () => {
  try {
    return typeof window !== "undefined" && !!window.Capacitor?.isNativePlatform?.();
  } catch {
    return false;
  }
};

export { isNativePlatform };

export const growthbook = new GrowthBook({
  apiHost: growthbookApiHost,
  clientKey: growthbookClientKey,
  enableDevMode: growthbookEnableDevMode,
  trackingCallback: (experiment, result) => {
    // This is where you would send an event to your analytics provider
    console.log("Viewed Experiment", {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
});

// Wait for features to be available
const initGrowthbook = async () => {
  try {
    await growthbook.init({ streaming: true });

    // In Capacitor native builds the WebView reports host=localhost, which
    // makes URL-based GrowthBook targeting rules misfire. Pin the URL to the
    // production web URL so feature flags evaluate identically across platforms.
    if (isNativePlatform()) {
      const webUrl = import.meta.env.APP_BASE_WEB_APP_URL || "https://partners.hungryhub.com";
      growthbook.setURL(webUrl);
    }
  } catch (error) {
    console.error("Failed to initialize GrowthBook:", error);
    logRollbarError("Failed to initialize GrowthBook", {
      error: error,
      plugin: "growthbook",
      method: "initGrowthbook",
    });
  }
};

initGrowthbook();
